import { ClientJS } from 'clientjs';
import crc32 from 'crc/crc32';

import rudderanalytics from '../service/rudderstack';

const getClientInformation = () => {
  const client = new ClientJS();

  var canvas = client.getCanvasPrint();
  const customFingerPrint = client.getCustomFingerprint(canvas);
  const fingerPrint = client.getFingerprint();

  return {
    browserData: client.getBrowserData(),
    fingerPrint,
    customFingerPrint,

    userAgent: client.getUserAgent(),
    userAgentLowerCase: client.getUserAgentLowerCase(),

    browser: client.getBrowser(),
    browserVersion: client.getBrowserVersion(),
    browserMajorVersion: client.getBrowserMajorVersion(),

    isIE: client.isIE(),
    isChrome: client.isChrome(),
    isFirefox: client.isFirefox(),
    isSafari: client.isSafari(),
    isOpera: client.isOpera(),

    engine: client.getEngine(),
    engineVersion: client.getEngineVersion(),

    os: client.getOS(),
    osVersion: client.getOSVersion(),
    isWindows: client.isWindows(),
    isMac: client.isMac(),
    isLinux: client.isLinux(),
    isUbuntu: client.isUbuntu(),
    isSolaris: client.isSolaris(),

    device: client.getDevice(),
    deviceType: client.getDeviceType(),
    deviceVendor: client.getDeviceVendor(),

    cpu: client.getCPU(),

    isMobile: client.isMobile(),
    isMobileMajor: client.isMobileMajor(),
    isMobileAndroid: client.isMobileAndroid(),
    isMobileOpera: client.isMobileOpera(),
    isMobileWindows: client.isMobileWindows(),
    isMobileBlackBerry: client.isMobileBlackBerry(),

    isMobileIOS: client.isMobileIOS(),
    isIphone: client.isIphone(),
    isIpad: client.isIpad(),
    isIpod: client.isIpod(),

    screenPrint: client.getScreenPrint(),
    colorDepth: client.getColorDepth(),
    currentResolution: client.getCurrentResolution(),
    availableResolution: client.getAvailableResolution(),
    deviceXDPI: client.getDeviceXDPI(),
    deviceYDPI: client.getDeviceYDPI(),

    plugins: client.getPlugins(),
    isJava: client.isJava(),
    // javaVersion: client.getJavaVersion(), // functional only in java and full builds, throws an error otherwise
    isFlash: client.isFlash(),
    // flashVersion: client.getFlashVersion(), // functional only in flash and full builds, throws an error otherwise
    isSilverlight: client.isSilverlight(),
    silverlightVersion: client.getSilverlightVersion(),

    mimeTypes: client.getMimeTypes(),
    isMimeTypes: client.isMimeTypes(),

    isFont: client.isFont(),
    fonts: client.getFonts(),

    isLocalStorage: client.isLocalStorage(),
    isSessionStorage: client.isSessionStorage(),
    isCookie: client.isCookie(),

    timezone: client.getTimeZone(),

    language: client.getLanguage(),
    systemLanguage: client.getSystemLanguage(),

    isCanvas: client.isCanvas(),
    crc: crc32('' + fingerPrint).toString(16),
  };
};

export const submitClientInfo = (profile) => {
  const clientInfoSubmitted = localStorage.getItem('clientInfoSubmitted');
  if (!clientInfoSubmitted) {
    const clientInfo = getClientInformation();
    localStorage.setItem('clientInfoSubmitted', true);
    rudderanalytics.identify(profile.id, { profile, tenant: process.env.REACT_APP_TENANT_NAME });
    rudderanalytics.track('clientInfo', { ...clientInfo }, () => {
      console.log('clientInfo Submitted');
    });
  }
};
